import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';

let titleSceneG: any = null;
export default function G() {
    const { useLang, useEffect, useState } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail.SHP2');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (titleSceneG) {
                    AniContainer.removeScene(titleSceneG);
                    titleSceneG = null;
                }

                // maskSceneC = AniContainer.create({
                //     asyncFromTo: [['.shp2-detail-G .mask', { opacity: 0 }, { opacity: 1 }]],
                //     triggerElement: '.shp2-detail-G',
                //     triggerHook: 1,
                //     offset: window.innerHeight,
                //     duration: window.innerHeight / 2,
                // });

                // titleSceneG = AniContainer.create({
                //     asyncFromTo: [['.shp2-detail-G .title', { opacity: 0, y: window.innerHeight / 4 }, { opacity: 1, y: 0 }]],
                //     triggerElement: '.shp2-detail-G',
                //     triggerHook: 1,
                //     offset: window.innerHeight * 1.5,
                //     duration: window.innerHeight / 2,
                // });
                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                titleSceneG = AniContainer.create({
                    triggerElement: '.shp2-detail-G .sticky-box',
                    triggerHook: 1,
                    offset: '40%',
                    duration: 200,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (titleSceneG) {
                    AniContainer.removeScene(titleSceneG);
                    titleSceneG = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <>
            <EfSpec />
            <section id="shp2-detail-G" className={`shp2-detail-G shp2-detail-section ${css['shp2-detail-G']}`}>
                <div className={`sticky-box ${textEnter ? 'enter' : ''}`}>
                    <div className="img-box">
                        <EFPicture src={'/responsive/picture/smart-home-panel-2/launch/7.jpg'} alt={t('secG_title')} />
                        <div className="mask"></div>
                        <div className="title-box">
                            <h2 className="title">{t('secG_title')}</h2>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
